import { useMemo } from 'react'
import { useApiQuery } from '../../../lib/api'
import type { ChatwootInboxesResponse } from '../types'

// Loads the inboxes the operator can start a conversation in. Every Chatwoot
// conversation belongs to an inbox, so the "New conversation" dialog needs this
// list to let the operator choose where the outbound thread is created.
// `reloadKey` lets the caller force a refetch (e.g. a retry button after a
// failed load); bumping it changes the request payload, which re-runs the
// callable. It is stripped server-side, so it never reaches Chatwoot.
export function useChatwootInboxes(companyUid?: string | null, reloadKey = 0) {
  const requestData = useMemo(
    () => ({ companyUid: companyUid?.trim() || undefined, reloadKey }),
    [companyUid, reloadKey]
  )

  return useApiQuery<
    { companyUid?: string; reloadKey: number },
    ChatwootInboxesResponse
  >('chatwoot/get_inboxes', {
    data: requestData,
    startWithValue: { inboxes: [] },
  })
}
